import React from 'react';
import { renderFilter } from '../../../Shared/TextHelpers';

function CityStateProvince({
    practiceCity,
    filter,
    practiceStateProvince,
}) {
    return (
        <>
            {renderFilter(practiceCity, filter)}
            {practiceCity && practiceStateProvince ? ',' : ''}
            &nbsp;
            {renderFilter(practiceStateProvince, filter)}
            &nbsp;
        </>
    );
}

export default CityStateProvince;
